import {WithoutSummaryModel} from "../../../../../../../common/entity/dto/plain/withoutSummary.model";

export class TreatmentJourneyStepFeedbackModel extends WithoutSummaryModel {
    emailSubject: string;
    emailContent: string;
}